import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Link } from "react-router-dom"
import Home from "./pages/Home"
import About from "./pages/About"
import Vans from "./pages/Vans/Vans"
import VanDetail from "./pages/Vans/VanDetail"
import Login from "./pages/Login"
import Layout from "./components/Layout"
import Header from './components/Header';
import Dashboard from './pages/Host/Dashboard';
import Income from './pages/Host/Income';
import Reviews from './pages/Host/Reviews';
import HostLayout from './components/HostLayout';
import HostVans from './pages/Host/HostVans'; 
import HostVansDetail from './pages/Host/HostVansDetail'; 
import HostVansInfo from './pages/Host/HostVanInfo';
import HostVansPhotos from './pages/Host/HostVanPhotos';
import HostVansPricing from './pages/Host/HostVanPricing';
import HostVansLayout from './components/HostVansLayout';
import NotFound from './pages/NotFound';
import AuthRequired from './components/AuthRequired';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
          <Route path="/" element = {<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="vans" element={<Vans />} />
            <Route path="vans/:id" element={<VanDetail />} />
            <Route
            path="login"
            element={<Login />}
          />
            <Route element={<AuthRequired/>}>
              <Route path="host" element={<HostLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="income" element={<Income />} />
                <Route path="reviews" element={<Reviews />} />
                <Route path="vans" element={<HostVans />} />

                <Route path="vans/:id" element={<HostVansDetail/>}>
                  <Route index element={<HostVansInfo/>} />
                  <Route path="pricing" element={<HostVansPricing />} />
                  <Route path="photos" element={<HostVansPhotos />} />
                </Route>
              </Route>
            </Route>

            <Route path="*" element={<NotFound />} />
          </Route>
      </Routes>
    </BrowserRouter>
  )
}
